import { Box } from '@mui/material'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import { styled } from '@mui/material/styles'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import {
  AttributeActionNames,
  AttributeResourceNames,
} from '../../models/AccessControl'
import { AbilityContext, Can } from '../../utils/AbilityUtil'
import { Chapter } from '../../models/Rule'
import { updateSelectedChapter } from '../../actions/rule'

const StyledListItem = styled(ListItem)(({ theme }) => ({
  '&& .Mui-selected': {
    backgroundColor: '#F0F6FF',
  },
}))

const ChapterList = () => {
  const dispatch = useDispatch<any>()
  const selectedChapter = useSelector(
    (state: RootState) => state.rule.selectedChapter,
  )
  const chapters = useSelector((state: RootState) => state.rule.chapters)

  const handleChapterSelection = (selectedChapter: Chapter) => {
    dispatch(updateSelectedChapter(selectedChapter))
  }

  return (
    <Can I={AttributeActionNames.Read} a={AttributeResourceNames.Clients}>
      <Box sx={{ width: '20%' }}>
        <List style={{ maxHeight: '65vh', overflowY: 'auto' }}>
          {chapters?.map((chapter: Chapter, index: any) => (
            <StyledListItem key={index} disablePadding>
              <ListItemButton
                selected={chapter.name === selectedChapter?.name}
                style={{ margin: 0, padding: '5px 16px' }}
              >
                <ListItemText
                  onClick={() => {
                    handleChapterSelection(chapter)
                  }}
                  primary={chapter.name}
                  primaryTypographyProps={{
                    margin: 0,
                    padding: 0,

                    fontSize: '12px',
                    fontWeight: 400,
                    textAlign: 'left',
                  }}
                />
              </ListItemButton>
            </StyledListItem>
          ))}
        </List>
      </Box>
    </Can>
  )
}

export default ChapterList
